/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AssessmentProposalAttachmentFile model module.
 * @module model/AssessmentProposalAttachmentFile
 * @version 1.0.0
 */
class AssessmentProposalAttachmentFile {
    /**
     * Constructs a new <code>AssessmentProposalAttachmentFile</code>.
     * @alias module:model/AssessmentProposalAttachmentFile
     */
    constructor() { 
        
        AssessmentProposalAttachmentFile.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AssessmentProposalAttachmentFile</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AssessmentProposalAttachmentFile} obj Optional instance to populate.
     * @return {module:model/AssessmentProposalAttachmentFile} The populated <code>AssessmentProposalAttachmentFile</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AssessmentProposalAttachmentFile();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('assessment_proposal_id')) {
                obj['assessment_proposal_id'] = ApiClient.convertToType(data['assessment_proposal_id'], 'Number');
            }
            if (data.hasOwnProperty('object_storage_path')) {
                obj['object_storage_path'] = ApiClient.convertToType(data['object_storage_path'], 'String');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('file_url')) {
                obj['file_url'] = ApiClient.convertToType(data['file_url'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AssessmentProposalAttachmentFile</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AssessmentProposalAttachmentFile</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['object_storage_path'] && !(typeof data['object_storage_path'] === 'string' || data['object_storage_path'] instanceof String)) {
            throw new Error("Expected the field `object_storage_path` to be a primitive type in the JSON string but got " + data['object_storage_path']);
        }
        // ensure the json data is a string
        if (data['file_url'] && !(typeof data['file_url'] === 'string' || data['file_url'] instanceof String)) {
            throw new Error("Expected the field `file_url` to be a primitive type in the JSON string but got " + data['file_url']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AssessmentProposalAttachmentFile.prototype['id'] = undefined;

/**
 * @member {Number} assessment_proposal_id
 */
AssessmentProposalAttachmentFile.prototype['assessment_proposal_id'] = undefined;

/**
 * @member {String} object_storage_path
 */
AssessmentProposalAttachmentFile.prototype['object_storage_path'] = undefined;

/**
 * @member {Date} created_at
 */
AssessmentProposalAttachmentFile.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
AssessmentProposalAttachmentFile.prototype['updated_at'] = undefined;

/**
 * @member {String} file_url
 */
AssessmentProposalAttachmentFile.prototype['file_url'] = undefined;






export default AssessmentProposalAttachmentFile;

